import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { dispatch, select } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { SiCardComponent } from '@siemens/element-ng/card';
import { SiIconComponent } from '@siemens/element-ng/icon';
import { SiModalService } from '@siemens/element-ng/modal';
import { AuthService } from '../../auth/services/auth.service';
import { EditTileDialogComponent } from '../../shared/components/edit-tile-dialog/edit-tile-dialog.component';
import { TileComponent } from '../../shared/components/tile/tile.component';
import { LoadSalData } from '../../shared/state/sal-data/sal-data.actions';
import { SalDataState } from '../../shared/state/sal-data/sal-data.state';

@Component({
    selector: 'app-sal-data',
    templateUrl: './sal-data.component.html',
    styleUrls: ['./sal-data.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TileComponent, SiIconComponent, SiCardComponent, TranslatePipe]
})
export class SalDataComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);
    private readonly dialog = inject(SiModalService);
    private readonly authService = inject(AuthService);
    private readonly translateService = inject(TranslateService);
    private readonly loadSalData = dispatch(LoadSalData);

    protected readonly data = select(SalDataState.data);
    protected readonly isLoading = select(SalDataState.isLoading);
    protected readonly skeletonItems = Array.from({ length: 4 });

    public ngOnInit(): void {
        this.refreshData();
        this.initRefreshTriggers();
    }

    private initRefreshTriggers(): void {
        this.translateService.onLangChange
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                tap(() => this.refreshData())
            )
            .subscribe();
    }

    protected addNewTile(): void {
        this.dialog.show(
            EditTileDialogComponent,
            {
                inputValues: { data: { mode: 'new', type: 'data' } },
                ignoreBackdropClick: false,
                keyboard: true,
                animated: true,
                class: 'modal-lg',
                ariaLabelledBy: 'edit-tile-dialog-title'
            },
            'close'
        );
    }

    protected isAdmin(): boolean {
        return this.authService.isAdmin();
    }

    private refreshData(): void {
        const lang = (
            this.translateService.getCurrentLang() ||
            this.translateService.getFallbackLang() ||
            'en'
        ).toLowerCase();
        void this.loadSalData({ lang });
    }
}
